import clsx from "clsx";
import React from "react";

export const InputTypes = {
  text: "t",
  userRole: "ur",
};

export default ({ label, data, classes, style , labelStyle, rowStyle, showCustomTitle = false, customTitle = null, boldLabel=false}) => {
  return (
    <div className={clsx(classes.muDetailWrapCF, boldLabel?classes.boldLabel:"")}  style={rowStyle}>
      <div title={label} className={clsx("clLabel",classes.muLabelsCF)}  style={labelStyle}>{label}</div>
      <div title={showCustomTitle && customTitle? customTitle : data} className={clsx("clContents",classes.muDetailsCF)} style={style}>
         {data}
      </div>
    </div>
  );
};